import React, { useContext } from 'react';
import { map } from "lodash";
import { IndexData } from './contexts';

const Downloads = () => {
  const { data: { downloads, downloads_table } } = useContext(IndexData);

  const columns = downloads_table.columns;

  const rows = downloads_table.rows;

  return (
    <>
      <div className="comparisons_plates">
        <div className="comparisons_section">
          <h2 className="comparisons_section-title -no-margin">
            Downloads
          </h2>
        </div>
        <div className="comparisons_plate-note -black">
          (among VZ account users)
        </div>
      </div>

      <table className="table -margin-top -fixed">
        <tbody>
          <tr>
            <th className="th th-section -center -width-25">Pages</th>
            <th className="th th-section -center -marked">Total</th>

            {map(columns, (column) => (
              <th className="th th-section -center" key={ column[0] }>{column[1]}</th>
            ))}
          </tr>

          {map(rows, (row) => (
            <tr key={ row[0] }>
              <th className="th"><b>{row[1]}</b></th>
              <th className="col-data -center -marked">{downloads[ row[0] ].total}</th>
              {map(columns, (column) => {
                const rec = downloads[ row[0] ][ column[0] ];
                return (
                  <th className="col-data -center" key={ column[0] }>
                    {rec.show && <span>{rec.text || rec.value}</span>}
                    {!rec.show && <span>n/a</span>}
                  </th>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};

export default Downloads;
